import React, { useEffect, useState } from "react";
import "../assets/css/Cookie.css"; // Import the stylesheet

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (!accepted) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <span className="cookie-text">
        We use cookies to improve your experience on Comparedly. By using our site, you accept our use of cookies.
      </span>
      <button className="cookie-accept-button" onClick={handleAccept}>
        Accept
      </button>
    </div>
  );
};

export default CookieBanner;
